// TODO
export const host = globalThis.window?.location.host.slice(-3);

export const GOOGLE_KEY: string = '6LeNrPIUAAAAAEHPsc9B0fHGf2yTM5-m38E1h6yq';
export const LIMIT_ITEM_ON_PAGE: number = 20;
